import {
  isTokenSuspiciousCheck,
  suspiciousCheckData,
} from '../../Wallets/labels';
import { PercentageChangeWithMaxValue } from '../../TelegramCalls/columns';
import { ColumnsProps } from '../columns';
import { hotTokenDataMapping } from '../hotTokenDataMapping';
import { useMemo } from 'react';
import { PerformanceStyle } from '../../../../components/alerts/performanceStyle';

export default function PriceColumn({ data, tokenStats }: ColumnsProps) {
  const mappedStats = useMemo(
    () => hotTokenDataMapping(tokenStats, data),
    [tokenStats, data]
  );

  const { price, priceChange, status } = mappedStats;

  return (
    <div
      className={
        isTokenSuspiciousCheck(suspiciousCheckData(tokenStats, data))
          ? 'xxs:text-dex-white-secondary'
          : ''
      }
    >
      {price ? (
        <div className="flex space-x-1 items-center">
          <PerformanceStyle
            className="text-xs"
            isOnlyFlashEnabled={true}
            pnl={price.toString()}
          />

          {priceChange && status !== 'RUG_PULL' && (
            <PercentageChangeWithMaxValue
              maxValue={999}
              className="xxs:text-xs"
              change={priceChange.toNumber()}
            />
          )}
        </div>
      ) : (
        <div className="text-xs">--</div>
      )}
    </div>
  );
}
